import { render, staticRenderFns } from "./ClientesFiltros.vue?vue&type=template&id=97bbd178&scoped=true&"
import script from "./ClientesFiltros.vue?vue&type=script&lang=js&"
export * from "./ClientesFiltros.vue?vue&type=script&lang=js&"
import style0 from "./ClientesFiltros.vue?vue&type=style&index=0&id=97bbd178&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97bbd178",
  null
  
)

export default component.exports